import toast from 'react-hot-toast';

export const toastSuccess = (message: string) => toast.success(message, { duration: 3000 });

export const toastError = (message: string, code?: string) =>
  toast.error(code ? `[${code}] ${message}` : message, { duration: 5000 });

export const toastInfo = (message: string, opts?: { duration?: number }) =>
  toast(message, { duration: opts?.duration ?? 3000 });
